import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index/index.vue"),
  },
  {
    path: "/departments",
    name: "departments",
    component: () => import("@/pages/departments.vue"),
  },
  {
    path: "/department/:id",
    name: "departmentDetails",
    component: () => import("@/pages/departmentDetails.vue"),
  },
  {
    path: "/therapists",
    name: "theraphists",
    component: () => import("@/pages/theraphists.vue"),
  },
  {
    path: "/team",
    name: "team",
    component: () => import("@/pages/team.vue"),
  },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import("@/pages/special-pages/page-404.vue"),
  },
  {
    path: "/register/:mobile",
    name: "Registration",
    component: () => import("@/pages/register.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    component: () => import("@/pages/privacy.vue"),
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import("@/pages/faq.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/pages/contact.vue"),
  },
  {
    path: "/information",
    name: "information",
    component: () => import("@/pages/information.vue"),
  },
  {
    path: "/room/:code",
    name: "ConferenceRoom",
    component: () => import("@/pages/room/index.vue"),
  },
  {
    path: "/invoice/:code",
    name: "Invoice",
    component: () => import("@/pages/invoice.vue"),
  },
  {
    path: "/payment_confirmed",
    name: "paymentConfirmed",
    component: () => import("@/pages/payment_confirmed.vue"),
  },
  {
    path: "/payment_failed",
    name: "paymentFailed",
    component: () => import("@/pages/payment_failed.vue"),
  },
  {
    path: "/delete-account",
    name: "deleteAccount",
    component: () => import("@/pages/deleteAccount/index.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/pages/about.vue"),
  },
  {
    path: "/our-process",
    name: "ourProcess",
    component: () => import("@/pages/our-process.vue"),
  },
  {
    path: "/ai-features",
    name: "aiFeatures",
    component: () => import("@/pages/ai-features.vue"),
  },
  {
    path: "/app/s/:code",
    name: "appLink",
    component: () => import("@/pages/app.vue"),
  },
  {
    path: "/quiz",
    name: "quiz",
    component: () => import("@/pages/quiz/index.vue"),
  },
  {
    path: "/knowledge",
    name: "knowledge",
    component: () => import("@/pages/knowledge-center.vue"),
  },
  {
    path: "/knowledge/:slug",
    name: "knowledgeArticle",
    component: () => import("@/pages/knowledge-article.vue"),
  },
  {
    path: "/admin/knowledge",
    name: "adminKnowledge",
    component: () => import("@/pages/admin/knowledge.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },
});

router.afterEach((to, from) => {
  if (to.path !== from.path) {
    window.scrollTo(0, 0);
  }
});

export default router;
